import React from "react";
import {API_CALL, BaseReportInfo, PARAMETERS, PropertyValue, Repair, REPAIR_TYPE, RepairsReport, Report} from "../types";
import {isError, isLoading, isSuccess, mapToObject, showErrorsInToast, translateError} from "../common";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment, {Moment} from "moment";
import {API} from "../api";
import {Link} from "react-router-dom";
import {PATHS} from "../paths";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {RepairsComponent} from "../components/common/RepairsComponent";
import {BlockTitleComponent} from "../components/common/BlockTitleComponent";
import {$enum} from "ts-enum-util";
import {AUTOSAVE_INTERVAL} from "../index";
import {ReadOnlyDatePickerComponent} from "../components/common/ReadOnlyDatePickerComponent";
import {ReportBaseInfoComponent} from "../components/common/ReportBaseInfoComponent";
import {ViewRepairsReportComponent} from "../components/repairs/ViewRepairsReportComponent";
import {ReportsList} from "../components/common/ReportsListComponent";
import {Modal} from "react-bootstrap";

interface RepairsPageState {
    working: boolean,
    loading: number,
    selectedDate: moment.Moment,
    report: RepairsReport | null,
    reports: RepairsReport[],
    shifts: PropertyValue[],
    formValues: Map<string, any>,
    dialogConfirmDeleteVisible: boolean,
    isPreviewMode: boolean,
}

export class RepairsPage extends React.Component<any, RepairsPageState> {
    autoSaveTrigger: any = null;
    reportForDeleting: RepairsReport | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            working: false,
            loading: 0,
            selectedDate: moment(),
            report: null,
            reports: [],
            shifts: [],
            formValues: new Map<string, any>(),
            dialogConfirmDeleteVisible: false,
            isPreviewMode: false,
        }

        this.addReport = this.addReport.bind(this);
        this.saveReport = this.saveReport.bind(this);
        this.autoSaveReport = this.autoSaveReport.bind(this);
        this.onChildChange = this.onChildChange.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.editReport = this.editReport.bind(this);
        this.loadReports = this.loadReports.bind(this);
        this.deleteReport = this.deleteReport.bind(this);
        this.doDeleteReport = this.doDeleteReport.bind(this);

    }

    setAutoSaveInterval() {
        this.autoSaveTrigger = window.setInterval(this.autoSaveReport, AUTOSAVE_INTERVAL);
    }

    clearAutoSaveInterval() {
        if (this.autoSaveTrigger) {
            window.clearInterval(this.autoSaveTrigger)
        }
    }

    componentDidMount() {
        this.loadParameters();
        this.loadReports();
        this.setAutoSaveInterval();
    }

    componentWillUnmount() {
        this.clearAutoSaveInterval();
    }

    handleFormChange(event: any) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        const fv = this.state.formValues;
        fv.set(name, value);
        this.setState({formValues: fv});
    }

    loadParameters() {
        this.setState({loading: this.state.loading + 1});
        API.getParameterValues(
            (apiCall: API_CALL) => {
                if (isSuccess(apiCall)) {
                    this.setState({
                        loading: this.state.loading - 1,
                        shifts: apiCall.data.data.items?.values
                    });
                }
            }, PARAMETERS.SHIFTS
        );
    }

    loadReports(newDate?: Moment) {
        API.getRepairs(
            (apiCall: API_CALL) => {
                this.setState({working: isLoading(apiCall)});

                if (isSuccess(apiCall)) {
                    const reports = apiCall.data.data.reports.map(
                        (r: any) => {
                            return {
                                ...r,
                                base_info: {
                                    report_date: r.report_date,
                                    shift_id: r.shift_id,
                                    from_time: r.from_time,
                                    to_time: r.to_time,
                                    man_cnt: r.man_cnt,
                                }
                            } as Report;
                        }
                    );
                    this.setState({reports: reports})
                }

            }, newDate ? newDate : this.state.selectedDate
        )
    }

    onChildChange(key: string, items: any) {
        this.setState(
            prevState => {
                return {formValues: prevState.formValues.set(key, items)}
            }
        )
    }


    addReport() {
        this.loadReports();

        const report = {
            id: -1,
            base_info: {
                report_date: this.state.selectedDate.format('DD.MM.YYYY'),
                shift_id: -1,
                man_cnt: 1,
                from_time: '',
                to_time: ''
            }
        } as RepairsReport;

        this.setState({report: report, formValues: new Map<string, any>(), isPreviewMode: false})
    }


    saveReport() {
        this.doSaveReport(false);
    }

    autoSaveReport() {
        if (this.state && this.state.report) this.doSaveReport(true);
    }

    doSaveReport(isAutosave: boolean = false) {
        if (
            !(
                this.state.formValues?.get('base_info')?.shift_id > -1 &&
                this.state.formValues?.get('base_info')?.man_cnt &&
                this.state.formValues?.get('base_info')?.man_cnt > 0)
        ) return;

        API.saveRepairs(
            (apiCall: API_CALL) => {
                if (isSuccess(apiCall)) {
                    if (!isAutosave) {
                        this.setState({report: null});
                        this.loadReports();
                    } else {
                        // @ts-ignore
                        this.state.report.id = apiCall.data.data.report?.id || -1;
                    }
                }
                if (isError(apiCall)) {
                    if (!isAutosave) showErrorsInToast(apiCall, "Данните не бяха запазени поради следните грешки:", translateError);
                }

                this.setState({working: isLoading(apiCall)});
            }, {
                ...mapToObject(this.state.formValues), report_date: this.state.selectedDate?.toISOString(true)
            }, this.state.report?.id
        );

    }

    editReport(r: RepairsReport, isPrint: boolean = false) {
        const fv: Map<string, any> = new Map<string, any>();
        const rd = JSON.parse(r.request_data);

        fv.set('shiftId', rd.shiftId);
        fv.set('repair_type', rd.repair_type);
        fv.set('comments', rd.comments);

        r.repairs = rd.repairs.map(
            (i: any) => {
                return {...i} as Repair;
            }
        );

        let isPreviewMode = false;
        if (isPrint || (r.user.id !== API.user?.id && !(API.user?.is_admin === 'Y'))) {
            isPreviewMode = true;
        }
        this.setState({report: r, formValues: fv, isPreviewMode: isPreviewMode});
    }


    deleteReport(report: RepairsReport) {
        this.reportForDeleting = report;
        this.setState({dialogConfirmDeleteVisible: true});
    }


    doDeleteReport() {
        API.deleteRepairs(
            (apiCall: API_CALL) => {
                this.setState({working: isLoading(apiCall)});
                if (isError(apiCall)) {
                    showErrorsInToast(apiCall, 'Възникна следната грешка:');
                }
                if (isSuccess(apiCall)) {
                    this.setState({dialogConfirmDeleteVisible: false});
                    this.loadReports();
                }
            }, this.reportForDeleting?.id
        );
    }


    render() {
        return (
            <>
                <div className="container">

                    <div className="card shadow">

                        <div className="card-header text-center row">
                            <div className="col-2 text-left">
                                {
                                    (this.state.loading > 0) ?
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        :
                                        <>
                                            {
                                                this.state.report ?
                                                    <span className="btn btn-secondary"
                                                          onClick={() => {
                                                              this.setState({report: null});
                                                              this.loadReports();
                                                          }}><FontAwesomeIcon icon={faArrowLeft}/></span>
                                                    :
                                                    <Link to={PATHS.home + API.getAPITokenAsQuery()}>
                                                        <span className="btn btn-secondary"><FontAwesomeIcon icon={faArrowLeft}/></span></Link>
                                            }
                                        </>
                                }

                            </div>
                            <h2 className="col">Ремонти</h2>
                            <div className="col-2">
                            </div>
                        </div>

                        <div className="card-body">
                            <h4 className="card-title">
                                {
                                    this.state.report ?
                                        <>
                                            {
                                                this.state.report.id === -1 ? 'Добавяне' : 'Корекция'
                                            }
                                            &nbsp;на отчет
                                        </>
                                        :
                                        <>Ремонти отчети</>
                                }
                            </h4>
                            <div className="row">
                                <div className="col">
                                    {
                                        this.state.loading > 0 &&
                                        <div>Зареждам данните ...</div>
                                    }

                                    {
                                        this.state.loading === 0 && !this.state.report &&
                                        <>
                                            <div className="card bg-light p-3 mb-3">
                                                <form className="form-inline">
                                                    <div className={"text-nowrap row lh-2em "}>
                                                        <div className={"col-auto w-120px"}>Отчети за дата:&nbsp;</div>
                                                        <div className={"col-auto w-160px"}>
                                                            <ReadOnlyDatePickerComponent
                                                                value={this.state.selectedDate.format('DD.MM.YYYY')}
                                                                onChange={(date: Date) => {
                                                                    this.setState({selectedDate: moment(date)});
                                                                    this.loadReports(moment(date));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </>
                                    }


                                    <ReportsList
                                        working={!(this.state.loading === 0 && moment.isMoment(this.state.selectedDate) && !this.state.working && !this.state.report)}
                                        reports={this.state.reports}
                                        shifts={this.state.shifts}
                                        editReport={this.editReport}
                                        deleteReport={this.deleteReport}
                                    />


                                    {
                                        this.state.working &&
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    }

                                    {
                                        this.state.report && !this.state.isPreviewMode &&
                                        <>
                                            <ReportBaseInfoComponent
                                                onChange={(data: BaseReportInfo) => {
                                                    this.setState({formValues: this.state.formValues.set('base_info', data)});
                                                }}
                                                shifts={this.state.shifts.filter(
                                                    s => {
                                                        return this.state.reports.filter(
                                                            r => {
                                                                return r.base_info.shift_id == s.id &&
                                                                    s.id != this.state.report?.base_info.shift_id
                                                            }
                                                        ).length === 0
                                                    }
                                                )}
                                                reportInfo={this.state.report.base_info}
                                                addMiddleShift={false}
                                            />

                                            {
                                                this.state.formValues?.get('base_info')?.shift_id > -1 &&
                                                this.state.formValues?.get('base_info')?.man_cnt &&
                                                this.state.formValues?.get('base_info')?.man_cnt > 0 ?

                                                    <>
                                                        <RepairsComponent repairs={this.state.report?.repairs} onChange={this.onChildChange}/>

                                                        <div className="form-row mb-3">
                                                            <BlockTitleComponent title={"Бележки към отчета"}/>
                                                            <div className="col-12">
                                                <textarea className="form-control" rows={3} name="comments" onChange={this.handleFormChange}
                                                          value={this.state.formValues.get('comments')}/>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div><strong>Моля, изберете отдел, работна смяна и въведете броя на служителите, за да продължите с отчета...</strong></div>
                                            }


                                        </>
                                    }
                                    {
                                        this.state.report && this.state.isPreviewMode &&
                                        <>
                                            <ViewRepairsReportComponent
                                                report={this.state.report}
                                                shifts={this.state.shifts}
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="card-footer">
                            {
                                moment.isMoment(this.state.selectedDate) ?
                                    <>
                                        {
                                            !this.state.working &&
                                            <>
                                                {
                                                    this.state.report ?
                                                        !this.state.isPreviewMode &&
                                                        <>
                                                            <button className="btn btn-primary" onClick={this.saveReport}>Запази</button>
                                                            &nbsp;
                                                            <button className="btn btn-secondary" onClick={() => {
                                                                this.setState({report: null});
                                                                this.loadReports();
                                                            }}>Откажи
                                                            </button>
                                                        </>
                                                        :
                                                        this.state.reports.length < 2 &&
                                                        <>
                                                            <button className="btn btn-primary" onClick={this.addReport}>Добави нов</button>
                                                        </>
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <><span className="text-info">Моля, изберете дата...</span></>
                            }
                        </div>
                    </div>

                </div>

                <Modal
                    show={this.state.dialogConfirmDeleteVisible}
                    onHide={() => this.setState({dialogConfirmDeleteVisible: false})}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Внимание</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Моля, потвърдете изтриването!</p>
                    </Modal.Body>

                    <Modal.Footer>
                        {
                            this.state.working ?
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                :
                                <>
                                    <button type={"button"} className={"btn btn-secondary"} onClick={() => this.setState({dialogConfirmDeleteVisible: false})}>Откажи</button>
                                    <button type={"button"} className={"btn btn-primary"} onClick={this.doDeleteReport}>Изтрий</button>
                                </>
                        }
                    </Modal.Footer>
                </Modal>

            </>
        );
    }

}
